import { Rule } from 'antd/es/form';
import { AppDatePicker, AppFormItemProps, AppFormRangeItem } from 'components/atoms';
import { DATE_LABEL } from 'consts/labels/common';
import { formFields } from 'consts/form/formFields';
import { formElementRequiredText } from 'consts/errors/forms';
import { journalTexts } from 'consts/text';
import { AppFormRangeItemMode } from 'types';
import { datesTimelineValidator } from 'utils/validators';

export type AutomaticCheckJournalPeriodDatePickerElementProps = AppFormItemProps & {
    mode: AppFormRangeItemMode;
};

export const AutomaticCheckJournalPeriodDatePickerElement = ({
    mode,
    ...props
}: AutomaticCheckJournalPeriodDatePickerElementProps) => {
    const rules: Rule[] = [
        { required: true, message: formElementRequiredText },
        ({ getFieldValue }) =>
            datesTimelineValidator(getFieldValue, {
                mode,
                startValueFieldName: formFields.startDate,
                finishValueFieldName: formFields.finishDate,
                isFinishValueBeforeStartValueErrorText:
                    journalTexts.journalDetails.common.automaticCheckJournal.form
                        .periodEndBeforeStart,
                isStartValueAfterFinishValueErrorText:
                    journalTexts.journalDetails.common.automaticCheckJournal.form
                        .periodStartAfterEnd,
                unitToCompare: 'day',
            }),
    ];

    return (
        <AppFormRangeItem
            mode={mode}
            startValues={{
                label: journalTexts.journalDetails.common.automaticCheckJournal.form
                    .startCheckingDate,
                additionalText: DATE_LABEL,
                name: formFields.startDate,
                rules,
                accessibilityLabel: 'Pole data rozpoczęcia sprawdzania dziennika',
            }}
            finishValues={{
                label: journalTexts.journalDetails.common.automaticCheckJournal.form
                    .finishCheckingDateDate,
                additionalText: DATE_LABEL,
                name: formFields.finishDate,
                rules,
                accessibilityLabel: 'Pole data zakończenia sprawdzania dziennika',
            }}
            {...props}
        >
            <AppDatePicker
                autoComplete="off"
                accessibilityLabel="Pole data"
                placeholder="Wybierz datę"
            />
        </AppFormRangeItem>
    );
};
